import { render, staticRenderFns } from "./BaseFilterButton.vue?vue&type=template&id=87a5a9c8&scoped=true&"
import script from "./BaseFilterButton.vue?vue&type=script&lang=js&"
export * from "./BaseFilterButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilterButton.vue?vue&type=style&index=0&id=87a5a9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a5a9c8",
  null
  
)

export default component.exports